/**
 * Horizontal field-of-view (in degrees) per flame detector product family.
 * These values are hard-coded because they are not delivered via product data.
 */
export const FLAME_DETECTOR_FIELD_OF_VIEW: Record<string, number> = {
  "Flame 7000": 90,
  "Flame 3000": 120,
  "Flame 1500": 90,
  "Flame 1750": 90,
  "Flame 1350": 100,
  "Flame 1035": 100,
  "Flame 1050": 90,
};

export const DEFAULT_FLAME_DETECTOR_FIELD_OF_VIEW = 90;

export const DEFAULT_FLAME_DETECTOR_CONE_ROTATION = 0;
